import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Observable, Subscription, map } from 'rxjs';

import { PedidoService } from 'src/app/core/services/http/pedido.service';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { VendasDetalheModel } from '../../models/vendas-detalhe.model';
import { StatusPedidoEnum } from '../../enums/status-pedido.enum';
import { RejeitarPedidoRequest } from '../../models/pedido.model';
import { DialogStateUtil } from '../../utils/dialog-state.util';
import { ToastService } from 'src/app/core/services/behavior/toast.service';

@Component({
  selector: 'app-aceitar-rejeitar-pedido-delivery-dialog',
  templateUrl: './aceitar-rejeitar-pedido-delivery-dialog.component.html',
  styleUrls: ['./aceitar-rejeitar-pedido-delivery-dialog.component.scss']
})
export class AceitarRejeitarPedidoDeliveryDialogComponent implements OnInit, OnDestroy {
  /**
    * @description DialogProp 
  */
  readonly numeroComanda: number;

  private _subs$: Subscription[] = [];

  public dets$: Observable<VendasDetalheModel[]>;
  public enviandoReq: boolean = false;

  constructor(
    private _alertCtrl: AlertController,
    private _modalCtrl: ModalController,
    private _pedidoService: PedidoService,
    private _toastService: ToastService
  ) { }
  ngOnDestroy(): void {
    this._subs$.forEach(l => l.unsubscribe());
  }

  public async cancel(): Promise<void> {
    await this._modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
  }

  public confirmarPedido() {
    this.enviandoReq = true;

    const sub$ = this._pedidoService.aceitarPedido(this.numeroComanda)
      .subscribe(res => {
        this.enviandoReq = false;
        if (res.success) {
          this._modalCtrl.dismiss(null, ModalRoleEnum.CONFIRM);

          DialogStateUtil.dialogIsClosed();
        }
      });

    this._subs$.push(sub$);
  }

  public ngOnInit() {
    this.dets$ = this._pedidoService.obterListaDets(this.numeroComanda).pipe(map(l => l.success ? l.data : []));
  }

  public async recusarPedidoAlert() {
    const alertInputs = [
      {
        placeholder: 'Motivo da rejeição',
        tabindex: 1
      },
    ];

    const alertButtons = [
      {
        text: 'Cancelar',
        role: ModalRoleEnum.CANCEL
      },
      {
        text: 'Confirmar',
        role: ModalRoleEnum.CONFIRM
      }
    ];

    const alert = await this._alertCtrl.create({
      header: 'Atenção',
      message: 'Digite o motivo da rejeição.',
      buttons: alertButtons,
      inputs: alertInputs
    });

    await alert.present();

    DialogStateUtil.dialogIsOpen();

    const res = await alert.onDidDismiss();

    DialogStateUtil.dialogIsClosed();

    if (res.role === ModalRoleEnum.CONFIRM) {
      const motivo = res.data.values[0];

      if (motivo.trim().length === 0) {
        this._toastService.show('O motivo da rejeição é obrigatório.', 'error');
        return;
      }

      const request = new RejeitarPedidoRequest(this.numeroComanda, motivo);

      const sub$ = this._pedidoService.rejeitarPedido(request).subscribe(res => {
        if (res.success) {
          this._modalCtrl.dismiss(null, ModalRoleEnum.CONFIRM);
        }
      });

      this._subs$.push(sub$);
    }
  }

  @HostListener('window:keydown', ['$event'])
  public async handleKeyboardEvent(event: KeyboardEvent): Promise<void> {
    switch (event.key) {
      case 'F5':
        event.preventDefault();
        event.stopPropagation();

        this.confirmarPedido();

        break;
    }
  }
}
